<div *ngIf="!isAddModuleDropdown" class="modulePreviewContainer">
    <div class="previewContentContainer" *ngIf="module?.ModuleID == currentModuleid" id="{'modulePreview' + module.ModuleID}">
        <div class="" style="flex-grow: 13; flex-shrink: 13;
                    align-items: center; justify-content: center; padding-left: 5px;">
            <div class="previewContent" style="flex-grow: 5; flex-shrink: 5; height: 210px; display: flex; padding-top: 5px; padding-bottom: 5px;">
                <img style="height: 200px; max-height: 200px; width: 390px; max-width: 390px;"
                     *ngIf="this.module?.PreviewImagePath != ''" [src]="this.module?.PreviewImagePath" />
                <div style="color: #A8AFB9; font-size: 16px; text-align: center;" *ngIf="this.module?.PreviewImagePath == ''">
                    <span runat="server" cvLocalizedText [langSection]="'ModulePreview'" [langKey]="'No_Preview'"></span><br>
                    <span runat="server" cvLocalizedText [langSection]="'ModulePreview'" [langKey]="'Available'"></span><br>
                </div>
            </div>
            <div class="previewContent" style="flex-grow: 3; flex-shrink: 3; align-content: flex-start; justify-items: center; padding: 5px;padding-top: 8px;">
                <!--Module Preview Description/OverView-->
                <div class="previewData">
                    <div class="previewDataContent">
                        {{getLocalizedDict(this.module?.ModuleName)}}
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<!--CXONE PREVIEW-->
<div *ngIf="isAddModuleDropdown" class="modulePreviewContainer" [ngClass]="{'add-module-dropdown': isAddModuleDropdown, 'modulePreviewContainerSearch' : isSearch}">    
    <div class="previewContentContainer" *ngIf="module?.ModuleID == currentModuleid" id="{'modulePreview' + module.ModuleID}">
        <div class="tooltip-wrapper">
            <div class="tooltip-title-wrapper" [ngClass]="{
                'acd-color': acdTab === widgetGroupName(this.module.ModuleGroup), 
                'qm-color': qmTab === widgetGroupName(this.module.ModuleGroup), 
                'analytics-color': analyticsTab === widgetGroupName(this.module.ModuleGroup), 
                'metrics-color': metricsTab === widgetGroupName(this.module.ModuleGroup),
                'coaching-color': coachingTab == widgetGroupName(this.module.ModuleGroup),
                'pm-color': pmTab === widgetGroupName(this.module.ModuleGroup)}">
                <div class="tooltip-text text-start">
                    <svg class="moduleGroupIcon icon-22">
                        <use [attr.href]="getWidgetGroupSvgPath(this.module.ModuleGroup)"></use>
                    </svg>
                    <span class="tooltip-title">
                    {{module.LocalizedGroup}}
                    </span>
                </div>
            </div>
            <div class="previewContent tooltip-content">
                <!--Module Preview Description/OverView-->
                <div class="previewData">
                    <div class="previewDataContent">
                        <div class="tooltip-text widget-title"><span class="tooltip-title">{{module.LocalizedName}}</span></div>
                        {{getLocalizedDict(this.module?.ModuleName)}}
                    <div style="margin-top: 15px; margin-bottom: 0px;">
                        <b>{{cvLocalizationService.getCachedText("Common", "For", "For: ")}}</b>
                        {{cvLocalizationService.getCachedText("ModulePreview", getWidgetDescriptionForSection(this.module.ModuleGroup, this.module.ModuleName), "")}}
                    </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
